import React from 'react';

import { TrackService } from 'common/services';

import { GenericError } from '../error/generic';

type TErrorBoundaryProps = {
  children: React.ReactNode;
};

type TErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<TErrorBoundaryProps, TErrorBoundaryState> {
  constructor(props: TErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, errorInfo: React.ErrorInfo) {
    this.setState({
      hasError: true,
    });

    TrackService.trackError(error, { handled: false, componentStack: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return <GenericError />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
